import { AutogenModelClaimReason, AutogenRowClaimReason } from "./autogen/AutogenModelClaimReason";

export class ModelClaimReason extends AutogenModelClaimReason<RowClaimReason> {
	constructor() {
		super(RowClaimReason);
	}
}

export class RowClaimReason extends AutogenRowClaimReason {
}